var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:[_vm.theme + '-theme']},[_c('top-nav'),_c('div',{staticClass:"app-content"},[_c('keep-alive',[_c('router-view',{staticClass:"app-router-view"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }